/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  TextField,
  Button,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import ButtonFooter from "components/ButtonFooter";
import { useEffect } from "react";
import {
  getAccountCodeList,
  getDepartmentList,
  getTaxAllocation,
  updateTaxAllocation,
} from "services/setting";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getTaxProfile, updateInvoiceDetail } from "services/accountPayable";
import SnackbarUtils from "utils/SnackbarUtils";
import NumberFormatInput from "components/NumberFormatInput";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { matchSorter } from "match-sorter";
import ListBox from "components/ListBox";
import PopperListBox from "components/PopperListBox";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: "#1976d2",
    color: "white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
  },
  rootTitle: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  rateInput: {
    width: "100px",
    textAlign: "right",
  },
  selectSmall: {
    width: "100%",
    height: theme.spacing(2.5),
    fontSize: "0.875rem",
  },
  totalCell: {
    fontWeight: "bold",
  },
  totalValue: {
    color: "#4caf50",
  },
  noteText: {
    color: theme.palette.text.secondary,
    fontSize: "0.75rem",
  },
  wrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DialogSettingInputTax = ({
  open,
  onClose,
  viewMode,
  openBtnCalculate,
  invoiceData,
  setDataInvoice,
}) => {
  const classes = useStyles();
  const [isBtnLoading, setBtnLoading] = React.useState(false);
  const [data, setData] = useStateWithCallbackLazy();
  const [lookupList, setLookupList] = React.useState({
    accountCodeList: [],
    departmentList: [],
    taxProfileList: [],
  });

  const Save = async () => {
    const { Code, UserMessage } = await updateTaxAllocation(data);
    if (Code === 0) {
      SnackbarUtils.success(UserMessage);
      handleClose();
    }
    setBtnLoading(false);
  };

  const handleClose = () => {
    onClose();
  };

  const fetchTaxProfile = async () => {
    const { Data } = await getTaxProfile();
    setLookupList((state) => ({
      ...state,
      taxProfileList: Data,
    }));
  };
  const fetchAccLookup = async () => {
    const { Data } = await getAccountCodeList("Gl");
    setLookupList((state) => ({
      ...state,
      accountCodeList: Data,
    }));
  };
  const fetchDeptLookup = async () => {
    const { Data } = await getDepartmentList();
    setLookupList((state) => ({
      ...state,
      departmentList: Data,
    }));
  };

  const fetchDetail = async () => {
    const response = await getTaxAllocation();
    console.log(response.Data);
    if (response) {
      setData(response.Data);
    }

    setBtnLoading(false);
  };

  useEffect(() => {
    fetchDetail();
    fetchTaxProfile();
    fetchAccLookup();
    fetchDeptLookup();
  }, []);

  const handleRateChange = (id, value) => {
    const newRate = parseFloat(value) || 0;

    // Only process if this is Tax 1 (Claim)
    if (id === 1) {
      // Validate that the rate is between 1-100
      const validatedRate = Math.max(1, Math.min(100, newRate));

      setData((prev) => {
        // Calculate Tax 2 as 100 - Tax 1
        const tax2Rate = 100 - validatedRate;

        return prev.map((tax) => {
          if (tax.TaxAllocationId === 1) {
            return { ...tax, Percent: validatedRate };
          } else if (tax.TaxAllocationId === 2) {
            return { ...tax, Percent: tax2Rate };
          }
          return tax;
        });
      });
    } else {
      // For Tax 2, just update as normal
      setData((prev) =>
        prev.map((tax) =>
          tax.TaxAllocationId === id ? { ...tax, Percent: newRate } : tax,
        ),
      );
    }
  };

  const totalRate = data?.reduce((sum, tax) => sum + tax.Percent, 0);

  const DialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <MuiDialogTitle
        disableTypography
        className={classes.rootTitle}
        {...other}
      >
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  };

  const filterOptions = (options, { inputValue }, optKey, optDesc) => {
    return matchSorter(options, inputValue, {
      keys: [`${optKey}`, `${optDesc}`],
    });
  };

  const calculateTax = async () => {
    setBtnLoading(true);
    // Implement your tax allocation logic here
    // This is just a placeholder function
    console.log("Calculating tax allocation...", invoiceData, data);

    //1. get status claim rate from tax allocation
    const claimTax = data.find((tax) => tax.Status === "Claim");
    const unClaimTax = data.find((tax) => tax.Status === "Unclaimed");

    //2. calculate tax amount by claim rate and unclaim rate multiply with loop tax amount invoice detail replace in same detail taxAmount is InvdTaxC1 and unClaimTaxAmount is InvdTaxC2
    const updatedDetail = invoiceData.Detail.map((detail) => {
      const taxAmount = (detail.InvdTaxA1 * claimTax.Percent) / 100;
      const unClaimTaxAmount = (detail.InvdTaxA1 * unClaimTax.Percent) / 100;
      const taxBaseAmount = (detail.InvdTaxC1 * claimTax.Percent) / 100;
      const unClaimTaxBaseAmount =
        (detail.InvdTaxC1 * unClaimTax.Percent) / 100;
      detail.InvdTaxA1 = taxAmount;
      detail.InvdTaxC1 = taxBaseAmount;
      detail.Tax1Overwrite = true;
      detail.TaxProfileCode1 = claimTax.TaxProfileCode;
      detail.InvdT1DrDeptCode = claimTax.DeptCode;
      detail.InvdT1Dr = claimTax.AccCode;

      detail.InvdTaxA2 = unClaimTaxAmount;
      detail.InvdTaxC2 = unClaimTaxBaseAmount;
      detail.Tax2Overwrite = true;
      detail.InvdTaxT2 = "Add";
      detail.TaxProfileCode2 = unClaimTax.TaxProfileCode;
      detail.InvdT2DrDeptCode = unClaimTax.DeptCode;
      detail.InvdT2Dr = unClaimTax.AccCode;

      return detail;
    });

    setDataInvoice((prev) => ({
      ...prev,
      Detail: updatedDetail,
    }));

    const { Code, UserMessage } = await updateInvoiceDetail(invoiceData);
    if (Code === 0) {
      setBtnLoading(false);
      SnackbarUtils.success("Tax allocation calculated successfully");
      handleClose();
    } else {
      SnackbarUtils.warning(UserMessage); 
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      aria-labelledby="confirmation-dialog-title"
      open={open}
    >
      <DialogTitle id="customized-dialog-title" onClose={onClose}>
        Input Tax Allocation Setup
      </DialogTitle>

      <DialogContent dividers>
        <Table>
          <TableHead style={{ backgroundColor: "#f5f5f5" }}>
            <TableRow>
              <TableCell style={{ fontWeight: "bold" }}>Tax</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Rate %</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Tax Profile</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Dept. Code</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Account Code</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((tax) => (
              <TableRow key={tax.id}>
                <TableCell>
                  <Typography
                    variant="body2"
                    style={{
                      color: tax.Name.includes("(Claim)")
                        ? "#4caf50"
                        : "#757575",
                      fontWeight: tax.Name.includes("(UnClaim)")
                        ? "bold"
                        : "normal",
                    }}
                  >
                    {tax.Name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    inputProps={{ style: { textAlign: "right" } }}
                    InputProps={{
                      inputComponent: NumberFormatInput,
                    }}
                    value={tax.Percent}
                    onChange={(e) =>
                      handleRateChange(tax.TaxAllocationId, e.target.value)
                    }
                    disabled={viewMode}
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    size="small"
                    style={{ width: 160 }}
                    options={lookupList["taxProfileList"]}
                    disableClearable
                    disableListWrap
                    value={tax.TaxProfileCode}
                    onChange={(e, newItem) => {
                      setData((prev) =>
                        prev.map((t) =>
                          t.TaxAllocationId === tax.TaxAllocationId
                            ? {
                                ...t,
                                TaxProfileCode: newItem.TaxProfileCode,
                              }
                            : t,
                        ),
                      );
                    }}
                    ListboxComponent={ListBox}
                    PopperComponent={PopperListBox}
                    classes={{
                      option: classes.option,
                    }}
                    getOptionLabel={(option) => {
                      return typeof option === "object" ? option.Code : option;
                    }}
                    getOptionSelected={(option, value) => option.Code === value}
                    renderOption={(option, { inputValue }) => {
                      const mergestring = `${option.Code} : ${option.Description}`;

                      const matches = match(mergestring, inputValue);
                      const parts = parse(mergestring, matches);
                      return (
                        <div>
                          {parts.map((part, index) => (
                            <span
                              key={index}
                              style={{ fontWeight: part.highlight ? 700 : 400 }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      );
                    }}
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label={`* Tax Profile ${tax.TaxAllocationId}`}
                        margin="dense"
                      />
                    )}
                    filterOptions={(options, { inputValue }) =>
                      filterOptions(
                        options,
                        { inputValue },
                        "Code",
                        "Description",
                      )
                    }
                    disabled={viewMode}
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    size="small"
                    style={{ width: 160 }}
                    options={lookupList["departmentList"]}
                    disableClearable
                    disableListWrap
                    value={tax.DeptCode}
                    onChange={(e, newItem) => {
                      setData((prev) =>
                        prev.map((t) =>
                          t.TaxAllocationId === tax.TaxAllocationId
                            ? {
                                ...t,
                                DeptCode: newItem.DeptCode,
                                DepartmentDesc: newItem.Description,
                              }
                            : t,
                        ),
                      );
                    }}
                    ListboxComponent={ListBox}
                    PopperComponent={PopperListBox}
                    classes={{
                      option: classes.option,
                    }}
                    getOptionLabel={(option) => {
                      return typeof option === "object"
                        ? option.DeptCode
                        : option;
                    }}
                    getOptionSelected={(option, value) =>
                      option.DeptCode === value
                    }
                    renderOption={(option, { inputValue }) => {
                      const mergestring = `${option.DeptCode} : ${option.Description}`;

                      const matches = match(mergestring, inputValue);
                      const parts = parse(mergestring, matches);
                      return (
                        <div>
                          {parts.map((part, index) => (
                            <span
                              key={index}
                              style={{ fontWeight: part.highlight ? 700 : 400 }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      );
                    }}
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Department"
                        margin="dense"
                      />
                    )}
                    filterOptions={(options, { inputValue }) =>
                      filterOptions(
                        options,
                        { inputValue },
                        "DeptCode",
                        "Description",
                      )
                    }
                    disabled={viewMode}
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    size="small"
                    style={{ width: 160 }}
                    options={lookupList["accountCodeList"]}
                    disableClearable
                    disableListWrap
                    value={tax.AccCode}
                    onChange={(e, newItem) => {
                      setData((prev) =>
                        prev.map((t) =>
                          t.TaxAllocationId === tax.TaxAllocationId
                            ? {
                                ...t,
                                AccCode: newItem.AccCode,
                                AccDesc: newItem.Description,
                              }
                            : t,
                        ),
                      );
                    }}
                    ListboxComponent={ListBox}
                    PopperComponent={PopperListBox}
                    classes={{
                      option: classes.option,
                    }}
                    getOptionLabel={(option) => {
                      return typeof option === "object"
                        ? option.AccCode
                        : option;
                    }}
                    getOptionSelected={(option, value) =>
                      option.AccCode === value
                    }
                    renderOption={(option, { inputValue }) => {
                      const mergestring = `${option.AccCode} : ${option.Description}`;

                      const matches = match(mergestring, inputValue);
                      const parts = parse(mergestring, matches);
                      return (
                        <div>
                          {parts.map((part, index) => (
                            <span
                              key={index}
                              style={{ fontWeight: part.highlight ? 700 : 400 }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      );
                    }}
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Account Code"
                        margin="dense"
                      />
                    )}
                    filterOptions={(options, { inputValue }) =>
                      filterOptions(
                        options,
                        { inputValue },
                        "AccCode",
                        "Description",
                      )
                    }
                    disabled={viewMode}
                  />
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell style={{ fontWeight: "bold" }}>Total:</TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                  color: totalRate === 100 ? "#4caf50" : "red",
                }}
                className={classes.totalCell}
              >
                {totalRate?.toFixed(2)}%
              </TableCell>
              <TableCell colSpan={3}>
                {/* <Typography variant="caption" className={classes.noteText}>
                  *ผลรวมต้องเท่ากับ 100% เสมอ
                </Typography> */}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </DialogContent>
      {viewMode ? null : (
        <DialogActions>
          <ButtonFooter
            noBorder
            disabled={isBtnLoading}
            SaveFnc={() => Save()}
            CancelFnc={() => handleClose()}
          />
        </DialogActions>
      )}
      {openBtnCalculate ? (
        <DialogActions>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item>
              <div className={classes.wrapper}>
                <Button
                  disabled={isBtnLoading}
                  variant="contained"
                  color="primary"
                  onClick={calculateTax}
                >
                  {isBtnLoading ? "Calculating..." : "Allocate Tax"}
                </Button>
                {isBtnLoading && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </Grid>
          </Grid>
        </DialogActions>
      ) : null}

      <pre>
        {process.env.NODE_ENV === "development"
          ? JSON.stringify(data, 0, 2)
          : ""}
      </pre>
    </Dialog>
  );
};

export default DialogSettingInputTax;
